import { Avulso } from '../models';
import { makeCrudObject } from './api';

export default makeCrudObject<Avulso>('avulsos');
